import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { GtagEventDirective } from './googla-tag-manager-event.directive';
import { TrackingService } from '../tracking.service';
import { GtagConfig } from './google-tag-manager.interface';

export * from './googla-tag-manager-event.directive';

@NgModule({
  declarations: [GtagEventDirective],
  imports: [CommonModule, RouterModule],
  exports: [GtagEventDirective],
})
export class GoogleTagManagerModule {
  static forRoot(
    config: GtagConfig
  ): ModuleWithProviders<GoogleTagManagerModule> {
    return {
      ngModule: GoogleTagManagerModule,
      providers: [
        TrackingService,
        { provide: 'config', useValue: config || {} },
      ],
    };
  }
}
